import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-star-fill text-xl text-accent-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                星空传媒
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              汇聚全系列高清视频资源，<br />
              无需注册，免费在线观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-400">
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                contact@xingkongchuanmei.com
              </li>
              <li className="text-sm text-foreground-400">
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-phone-line text-foreground-400"></i>
                </div>
                400-888-6666
              </li>
              <li className="text-sm text-foreground-400">
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-map-pin-line text-foreground-400"></i>
                </div>
                北京市朝阳区星空传媒大厦
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-accent-500 hover:text-background-50 transition-colors"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 星空传媒 版权所有 | 京ICP备2025XXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}